<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="400">
        <v-card class="mt-3 pa-1">
            <Title title="ライセンス">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <table>
                    <tr>
                        <td>ライセンスコード</td>
                        <td>{{targetLicense.code}}</td>
                    </tr>
                    <tr>
                        <td>組織名称</td>
                        <td>{{targetLicense.organization.name}}</td>
                    </tr>
                    <tr>
                        <td>有効期限</td>
                        <td>{{targetLicense.licenseInfo.toDate}}</td>
                    </tr>
                </table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        data: function () {
            return {
                isView: false,
                targetLicense: null
            }
        },
        methods: {
            /**
             * このダイアログを表示
             */
            show: function (license) {
                console.log(license)
                this.targetLicense = license
                this.isView = true
            }
        }
    }
</script>
